import React from 'react';
import { Section } from './ui/Section';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
export function Results() {
  const items = ['menos reacción automática ante el ruido', 'menos culpa por necesitar tu espacio', 'más calma al final del día', "más claridad para decir 'ahora no puedo' sin estallar"];
  return <Section alt data-id="element-104">
      <FadeIn data-id="element-105">
        <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-8" data-id="element-106">
          Cómo se nota cuando funciona
        </h2>
      </FadeIn>

      <StaggerContainer className="space-y-4" data-id="element-107">
        {items.map((item, index) => <StaggerItem key={index} className="pl-4 border-l-2 border-navy/30 py-1" data-id="element-108">
            <p className="text-charcoal text-base md:text-lg font-medium" data-id="element-109">
              {item}
            </p>
          </StaggerItem>)}
      </StaggerContainer>
    </Section>;
}